import { useTranslation } from '../../../lib/i18n';
import { Typography } from '../../symphony/ui';
import { SubAgentsTargetIcon } from './SubAgentsTargetIcon';
import styles from './FreeAgentRuns.module.css';

/**
 * "N free agent runs left" — the plan card's last line (Figma 11356-180894, the plan card's
 * "Free Runs Indicator": a 12px target glyph + Tiny/Medium 12/16 in the default ink).
 *
 * The count is the metasite's remaining FREE sub-agent allowance, not credits — a different
 * pool, which is why it gets its own line rather than joining the credits sentence. Renders
 * nothing at zero, exactly as both native apps gate it (`if store.subAgents > 0`), so an
 * account with none never reads "0 free agent runs left".
 */
export function FreeAgentRuns({ count }: { count: number | null }) {
  const { t } = useTranslation();
  if (count === null || count <= 0) return null;
  return (
    <div className={styles.row} data-testid="settings-free-agent-runs">
      <SubAgentsTargetIcon className={styles.glyph} size={12} />
      <Typography variant="p3" component="span">
        {t('settings.plan.freeRuns', { count })}
      </Typography>
    </div>
  );
}
